import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	addSection: {
		id: 'company-hub-section-cta.plus-button.add-section',
		defaultMessage: 'Add section',
		description: 'Label for the add section button',
	},
});
